import { render, staticRenderFns } from "./MtExpiryReport.vue?vue&type=template&id=4cd47546&"
import script from "./MtExpiryReport.vue?vue&type=script&lang=js&"
export * from "./MtExpiryReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports